$shm_tests_benchmark_table $mol_grid
	results /
	step_title \
	step_index -1
	has_benchmarks false
	records <= table_records *
	col_ids <= table_columns /
	col_head_content* <= column_title* /
	row_height 40
